<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6 mt-3 float-right">
                <b-button variant="primary" class="mb-2 float-right btn-custom" @click="showModal('Add')"><font-awesome-icon icon="plus"/></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-5"></div>
        <paginated-table ref="dataTable" :can-edit="false" :can-delete="false" :can-approve="false" :can-reject="false" :can-show="false" :can-edit-modal="true" :can-paid="false" v-on:editData="doEdit" :data-url="apiUrl" :data-key="dataKey" :data-columns="columns">
        </paginated-table>
        <b-modal ref="my-modal" centered hide-footer :title="type + ' Leave Type'">
            <form v-on:submit.prevent="doSubmit">
                <label for="" class="mt-2 labels">Name *</label>
                <b-form-input type="text" class="mb-3" placeholder="Enter Name" v-model="model.name" name="name" v-bind:class="errors.has('name') ? 'is-invalid':''" v-validate="'required'"></b-form-input>
                <label for="" class="mt-2 labels">Quota *</label>
                <input type="number" pattern="[0-9]+([\.,][0-9]+)?" step="0.01" class="mb-3 form-control" placeholder="Enter Quota" v-model="model.quota" name="quota" v-bind:class="errors.has('quota') ? 'is-invalid':''" v-validate="'required'" />
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="model.isLeavePhoto"
                  name="checkbox-1"
                  value="true"
                  unchecked-value="false"
                  class="mt-2"
                >
                  Leave Photo ?
                </b-form-checkbox>
                
                <b-button class="mt-3" variant="secondary" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
                <b-button class="mt-3 float-right" variant="primary" type="submit"><font-awesome-icon icon="save"></font-awesome-icon>{{this.model.uuid !== null ? ' Update' : ' Submit'}} </b-button>
            </form>
        </b-modal>
        <edit-leave-type-modal ref="editLeaveType" v-on:getLeaveType="getLeaveType"></edit-leave-type-modal>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    import EditLeaveTypeModal from './EditLeaveTypeModal'
    export default {
        name: 'Leave-type',
        components: {
            PaginatedTable,
            EditLeaveTypeModal
        },
        data () {
            return {
                dataKey: 'leaveType',
                isLoading: false,
                apiUrl: window.AppConfig.apiUrl + 'leave-type',
                type: null,
                model: {
                    uuid: null,
                    name: null,
                    quota: null,
                    isLeavePhoto: null
                },
                columns: [
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'quota',
                        label: 'Quota',
                        sortable: true
                    },
                    {
                        key: 'createdAt',
                        label: 'Created',
                        sortable: false
                    },
                    {
                        key: 'statusLeaveType',
                        label: 'Status',
                        sortable: false
                    },
                    {
                        key: 'actionTypes',
                        label: ''
                    }
                ]
            }
        },
        mounted() {
            this.getLeaveType()
        },
        methods: {
            getLeaveType () {
                this.isLoading = true
                this.$refs.dataTable.getDataTable()
            },
            showModal(type) {
                this.model.name = null
                this.model.quota = null
                this.model.uuid = null
                this.model.isLeavePhoto = null
                this.$validator.reset();
                this.type = type
                this.$refs['my-modal'].show()
            },
            hideModal() {
                this.$refs['my-modal'].hide()
            },
            showEditModal (row) {
                this.type = row.type
                this.model.name = row.name
                this.model.quota = row.quota
                this.model.uuid = row.uuid
                this.model.isLeavePhoto = row.isLeavePhoto
                this.$refs['my-modal'].show()
            },
            doSubmit () {
                this.$validator.validateAll().then(res => {
                    if (res) {
                        if (this.model.uuid !== null) {
                            this.$http.patch(this.apiUrl + '/' + this.model.uuid, {
                                name: this.model.name,
                                quota: this.model.quota,
                                isLeavePhoto: this.model.isLeavePhoto
                            }).then(response => {
                                this.$store.dispatch('notification/success', 'Leave type has been updated.')
                                this.$refs.dataTable.doFilter()
                                this.hideModal()
                            }).catch(error => {
                                this.$store.dispatch('notification/error', error)
                            })
                        } else {
                            this.$http.post(this.apiUrl, {
                                name: this.model.name,
                                quota: this.model.quota,
                                isLeavePhoto: this.model.isLeavePhoto,
                                isActive: 1
                            }).then(response => {
                                this.$store.dispatch('notification/success', 'Leave type has been added.')
                                this.$refs.dataTable.doFilter()
                                this.hideModal()
                            }).catch(error => {
                                this.$store.dispatch('notification/error', error)
                            })
                        }
                    }
                })
            },
            doEdit (row) {
                this.$refs.editLeaveType.showModal(row)
            },
            doShowModal (row) {
                this.$refs.editLeaveType.showModal(row)
            },
        }
    }
</script>